/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RocketOrderOutboundSummaryInfoVo
 */
export interface RocketOrderOutboundSummaryInfoVo {
    /**
     * 订单ID
     * @type {number}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    orderId?: number;
    /**
     * 订单编号
     * @type {string}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    orderCode?: string;
    /**
     * 本地运输方式ID
     * @type {number}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    localTransportMethodId?: number;
    /**
     * 本地运输方式名称
     * @type {string}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    localTransportMethodName?: string;
    /**
     * 国际运输方式ID
     * @type {number}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    internationalTransportMethodId?: number;
    /**
     * 国际运输方式名称
     * @type {string}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    internationalTransportMethodName?: string;
    /**
     * 出库运单号
     * @type {string}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    ivc?: string;
    /**
     * 货位
     * @type {string}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    location?: string;
    /**
     * 收货人
     * @type {string}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    receiver?: string;
    /**
     * coupang入库码
     * @type {string}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    coupangInboundCode?: string;
    /**
     * coupang仓库名称
     * @type {string}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    coupangWarehouseName?: string;
    /**
     * 商品总数量
     * @type {number}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    goodsTotalQuantity?: number;
    /**
     * 商品总重量
     * @type {number}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    goodsTotalWeight?: number;
    /**
     * 总箱数
     * @type {number}
     * @memberof RocketOrderOutboundSummaryInfoVo
     */
    totalBox?: number;
}

/**
 * Check if a given object implements the RocketOrderOutboundSummaryInfoVo interface.
 */
export function instanceOfRocketOrderOutboundSummaryInfoVo(value: object): value is RocketOrderOutboundSummaryInfoVo {
    return true;
}

export function RocketOrderOutboundSummaryInfoVoFromJSON(json: any): RocketOrderOutboundSummaryInfoVo {
    return RocketOrderOutboundSummaryInfoVoFromJSONTyped(json, false);
}

export function RocketOrderOutboundSummaryInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RocketOrderOutboundSummaryInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'orderId': json['orderId'] == null ? undefined : json['orderId'],
        'orderCode': json['orderCode'] == null ? undefined : json['orderCode'],
        'localTransportMethodId': json['localTransportMethodId'] == null ? undefined : json['localTransportMethodId'],
        'localTransportMethodName': json['localTransportMethodName'] == null ? undefined : json['localTransportMethodName'],
        'internationalTransportMethodId': json['internationalTransportMethodId'] == null ? undefined : json['internationalTransportMethodId'],
        'internationalTransportMethodName': json['internationalTransportMethodName'] == null ? undefined : json['internationalTransportMethodName'],
        'ivc': json['ivc'] == null ? undefined : json['ivc'],
        'location': json['location'] == null ? undefined : json['location'],
        'receiver': json['receiver'] == null ? undefined : json['receiver'],
        'coupangInboundCode': json['coupangInboundCode'] == null ? undefined : json['coupangInboundCode'],
        'coupangWarehouseName': json['coupangWarehouseName'] == null ? undefined : json['coupangWarehouseName'],
        'goodsTotalQuantity': json['goodsTotalQuantity'] == null ? undefined : json['goodsTotalQuantity'],
        'goodsTotalWeight': json['goodsTotalWeight'] == null ? undefined : json['goodsTotalWeight'],
        'totalBox': json['totalBox'] == null ? undefined : json['totalBox'],
    };
}

export function RocketOrderOutboundSummaryInfoVoToJSON(json: any): RocketOrderOutboundSummaryInfoVo {
    return RocketOrderOutboundSummaryInfoVoToJSONTyped(json, false);
}

export function RocketOrderOutboundSummaryInfoVoToJSONTyped(value?: RocketOrderOutboundSummaryInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orderId': value['orderId'],
        'orderCode': value['orderCode'],
        'localTransportMethodId': value['localTransportMethodId'],
        'localTransportMethodName': value['localTransportMethodName'],
        'internationalTransportMethodId': value['internationalTransportMethodId'],
        'internationalTransportMethodName': value['internationalTransportMethodName'],
        'ivc': value['ivc'],
        'location': value['location'],
        'receiver': value['receiver'],
        'coupangInboundCode': value['coupangInboundCode'],
        'coupangWarehouseName': value['coupangWarehouseName'],
        'goodsTotalQuantity': value['goodsTotalQuantity'],
        'goodsTotalWeight': value['goodsTotalWeight'],
        'totalBox': value['totalBox'],
    };
}

